import React from "react";
import WebView from "../../components/WebView/Webview"
const Attributions: React.FC = () => {
  return (
    <React.Fragment>
      <div className=" bg-no-repeat bg-center bg-cover h-[29em] w-full bg-[url('https://static.igem.wiki/teams/5058/topoattribution.svg')]"/>
      <WebView/>
    </React.Fragment>
  );
};

export default Attributions;
